import { Box } from '@mui/material';

const CircleColor = ({ color, sx = {} }) => {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block', // Thêm dòng này để span nhận width & height
        borderRadius: '50%',
        bgcolor: color || 'transparent',
        border: '1px solid #000',
        width: 24,
        height: 24,
        ...sx
      }}
    />
  );
};

export default CircleColor;
